import { getTranslation } from '@/lib/translations';

export const useLanguage = () => {
  const t = (key: string): string => getTranslation(key);

  return { t };
};
